// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"3d4941fe","171":"da4d6e17","378":"ef4d14e1","453":"c0c57d4d"}[chunkId] + ".chunk.js";
};